module.exports = {
  GT: 0,
  LT: 1,
  EQ: 2,
  NOT_EQ: 3,
  IN: 4,
  NOT_IN: 5,
  GTE: 6,
  LTE: 7,
};
